// Initialize the mobile logos slider (mobile only)
function initMobileSlider() {
  var $programSlider = $('.mlp-multi-section__logos-mobile');

  if ($programSlider.length === 0) return;

  function enableSlick() {
    if (window.innerWidth <= 991) {
      if (!$programSlider.hasClass('slick-initialized')) {
        $programSlider.slick({
          dots: false,
          arrows: true,
          prevArrow: $('.slick-prev'),
          nextArrow: $('.slick-next'),
          mobileFirst: true
        });
      }
    } else if ($programSlider.hasClass('slick-initialized')) {
      $programSlider.slick('unslick');
    }
  }

  enableSlick();
  $(window).off('resize.mobileSlider').on('resize.mobileSlider', enableSlick);
}

// Initialize the client quote slider (active on both mobile and desktop)
function initQuoteSlider() {
  var $slider = $('.mlp-multi-section__client-quote-slider');
  if ($slider.length === 0) return;

  $slider.slick({
    dots: false,
    prevArrow: $('.mlp-multi-section__client-quote-slider-container .slick-prev'),
    nextArrow: $('.mlp-multi-section__client-quote-slider-container .slick-next'),
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: true,
    speed: 500,
    cssEase: 'ease-in-out'
  });
}

// Initialize the cycle slider (mobile only)
function initCycleSlider() {
  var $slider = $('.mlp-cycle__object-slider');
  if ($slider.length === 0) return;

  function enableSlick() {
    if (window.innerWidth <= 991) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
          arrows: false,
          adaptiveHeight: true
        });

        $('.mlp-cycle__object-slider-item-bottom').off('click').on('click', function () {
          var currentSlide = $slider.slick('slickCurrentSlide');
          var totalSlides = $slider.slick('getSlick').slideCount;
          $slider.slick('slickGoTo', currentSlide === totalSlides - 1 ? 0 : currentSlide + 1);
        });
      }
    } else if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  enableSlick();
  $(window).off('resize.cycleResize').on('resize.cycleResize', enableSlick);
}

// Sticky navbar visibility
function initStickyNavbar() {
  var navbar = document.getElementById("navbar");
  var heroSection = document.querySelector(".mlp-hero");

  if (!navbar || !heroSection) {
    return; // Exit early if either element doesn't exist
  }

  function toggleNavbar() {
    if (window.scrollY > heroSection.offsetTop + heroSection.offsetHeight) {
      navbar.classList.add("navbar-visible");
    } else {
      navbar.classList.remove("navbar-visible");
    }
  }

  window.addEventListener("scroll", toggleNavbar);
}

// Hover effects
// function handleMouseEnter() {
//   var textElement = this.querySelector('.mlp-boxes__text');
//   var bigText = this.querySelector('.mlp-boxes__big');
//   var smallText = this.querySelector('.mlp-boxes__small');
//   var rolloverImage = this.querySelector('.mlp-boxes__rollover-image');

//   if (textElement) {
//     textElement.style.opacity = "1";
//     textElement.style.visibility = "visible";
//   }

//   if (bigText) bigText.style.transform = "translateY(5px)";
//   if (smallText) smallText.style.transform = "translateY(5px)";
//   if (rolloverImage) rolloverImage.style.opacity = "1";
// }

// function handleMouseLeave() {
//   var textElement = this.querySelector('.mlp-boxes__text');
//   var bigText = this.querySelector('.mlp-boxes__big');
//   var smallText = this.querySelector('.mlp-boxes__small');
//   var rolloverImage = this.querySelector('.mlp-boxes__rollover-image');

//   if (textElement) {
//     textElement.style.transition = "opacity 0.3s ease-in-out";
//     textElement.style.opacity = "0";
//     setTimeout(function() {
//       textElement.style.visibility = "hidden";
//     }, 300);
//   }

//   if (bigText) bigText.style.transform = "translateY(0)";
//   if (smallText) smallText.style.transform = "translateY(0)";
//   if (rolloverImage) rolloverImage.style.opacity = "0";
// }

// function initHoverEffects() {
//   var boxes = document.querySelectorAll('.mlp-boxes__box');
//   if (window.innerWidth > 991 && boxes.length > 0) {
//     boxes.forEach(function (box) {
//       box.addEventListener('mouseenter', handleMouseEnter);
//       box.addEventListener('mouseleave', handleMouseLeave);
//     });
//   }
// }

// function removeHoverEffects() {
//   var boxes = document.querySelectorAll('.mlp-boxes__box');
//   boxes.forEach(function (box) {
//     box.removeEventListener('mouseenter', handleMouseEnter);
//     box.removeEventListener('mouseleave', handleMouseLeave);
//   });
// }

// function handleResizeEvents() {
//   removeHoverEffects();
//   if (window.innerWidth > 991) {
//     initHoverEffects();
//   }
// }

// Mobile case study swap
function initMobileCaseStudySwap() {
  if ($(".mlp-case-study__item").length === 0) return;
  $(".mlp-case-study__mobile-container-item").on("click", function () {
    var $clickedItem = $(this);

    // if already active, do nothing
    if ($clickedItem.hasClass('active')) return;

    // remove active from previously active item and hide its details
    $(".mlp-case-study__mobile-container-item.active").removeClass("active").find(".mlp-case-study__mobile-container-info-container, .mlp-case-study__mobile-container-bottom").slideUp(250);

    // make clicked item active and show its details
    $clickedItem.addClass("active").find(".mlp-case-study__mobile-container-info-container, .mlp-case-study__mobile-container-bottom").slideDown(250);
  });
}

function initDesktopCaseStudySwap() {
  if ($(window).width() >= 991) {
    $(".mlp-case-study__item").off("click").on("click", function () {
      var $this = $(this);

      // Current main content
      var mainData = {
        field: $(".mlp-case-study__field").text().trim(),
        headline: $(".mlp-case-study__headline span").text().trim(),
        content: $(".mlp-case-study__content p").text().trim(),
        img: $(".mlp-case-study__image img").attr("src"),
        name: $(".mlp-case-study__name a").text().trim(),
        nameUrl: $(".mlp-case-study__name a").attr("href"),
        title: $(".mlp-case-study__title").text().trim()
      };

      // Clicked item content
      var clickedData = {
        field: $this.data("field"),
        headline: $this.data("headline"),
        content: $this.data("content"),
        img: $this.data("img"),
        name: $this.data("name"),
        nameUrl: $this.data("name-url"),
        title: $this.data("title")
      };

      // Swap main content
      $(".mlp-case-study__bottom").fadeOut(300, function () {
        $(".mlp-case-study__field").text(clickedData.field);
        $(".mlp-case-study__headline span").text(clickedData.headline);
        $(".mlp-case-study__content p").text(clickedData.content);
        $(".mlp-case-study__image img").attr("src", clickedData.img);
        $(".mlp-case-study__name a").attr("href", clickedData.nameUrl).text(clickedData.name);
        $(".mlp-case-study__title").text(clickedData.title);
        $(this).fadeIn(300);
      });

      // Update clicked item with previous main content
      $this.data(mainData);
      $this.find(".mlp-case-study__item-top span").text(mainData.field);
      $this.find(".mlp-case-study__item-headline").text(mainData.headline);
      $this.find(".mlp-case-study__item-content p").text(mainData.content);
      $this.find(".mlp-case-study__item-image img").attr("src", mainData.img);
    });
  }
}

$(document).ready(function () {
  initMobileCaseStudySwap();
  initMobileSlider();
  initQuoteSlider();
  initCycleSlider();
  initStickyNavbar();
  initDesktopCaseStudySwap();

  $(window).resize(function () {
    initDesktopCaseStudySwap();
  });
  //initHoverEffects();
  //$(window).off('resize.hoverEffects').on('resize.hoverEffects', handleResizeEvents);
});
